import { useEffect, useState } from "react";
import { parseExpression } from "cron-parser";
import { formatDistanceToNow, format } from "date-fns";
import { CalendarClock } from "lucide-react";

interface Props {
  schedule: string | null | undefined;
  active?: boolean | null;
}

const NextRunIndicator = ({ schedule, active }: Props) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  if (!schedule) return null;

  let next: Date | null = null;
  try {
    // pg_cron uses standard 5-field cron in UTC
    next = parseExpression(schedule, { utc: true, currentDate: now }).next().toDate();
  } catch {
    return (
      <span className="text-[10px] text-muted-foreground inline-flex items-center gap-1" title={`Unparseable schedule: ${schedule}`}>
        <CalendarClock size={10} /> {schedule}
      </span>
    );
  }

  const inactive = active === false;
  return (
    <span
      className={`text-[10px] inline-flex items-center gap-1 ${inactive ? "text-muted-foreground line-through" : "text-muted-foreground"}`}
      title={`Schedule: ${schedule} (UTC) • Next: ${format(next, "PPpp")}`}
    >
      <CalendarClock size={10} />
      {inactive ? "paused" : `next in ${formatDistanceToNow(next)}`}
    </span>
  );
};

export default NextRunIndicator;
